import { useCallback } from "react";
import type { ShareableScopeKind } from "../../../../shared/rbac/permissions";
import { navigate, routes } from "../../../lib/urls";

export function useOpenResource() {
  const openResource = useCallback(
    (scopeId: string, scopeKind: ShareableScopeKind) => {
      if (scopeKind === "space") navigate(routes.modal.space, { id: scopeId });
      else if (scopeKind === "skill")
        navigate(routes.modal.skill, { id: scopeId });
      else if (scopeKind === "service_account")
        navigate(routes.modal.serviceAccount, { id: scopeId });
      else if (scopeKind === "network")
        navigate(routes.modal.network, { id: scopeId });
      else navigate(routes.modal.connector, { id: scopeId });
    },
    []
  );

  return { openResource };
}
